(() => {
  const media = window.matchMedia('(min-width: 990px)');
  let observer;
  let resizeObserver;
  let frame;

  function align() {
    frame = 0;
    const banner = document.querySelector('.section-main-collection-banner');
    const grid = document.querySelector('.section-main-collection-product-grid');
    const bannerContent = banner?.querySelector('.section-content');
    const facets = grid?.querySelector('.facets-wrap');
    const sidebar = facets?.querySelector('.page-layout-sidebar');
    const mainContent = facets?.querySelector('.page-layout-main-content');
    let nextSection = banner?.nextElementSibling;
    while (nextSection && nextSection !== grid) {
      if (nextSection.getBoundingClientRect().height >= 1 && !nextSection.classList.contains('section-collection-grid')) break;
      nextSection = nextSection.nextElementSibling;
    }
    const enabled = media.matches && bannerContent && sidebar && mainContent &&
      facets.classList.contains('page-layout-with-sidebar') &&
      !sidebar.classList.contains('is-collapsed') &&
      nextSection === grid;

    if (!enabled) {
      document.documentElement.classList.remove('mp-collection-banner-aligned');
      grid?.style.removeProperty('--mp-collection-filter-offset');
      return;
    }

    document.documentElement.classList.add('mp-collection-banner-aligned');
    const offset = Math.max(0, Math.round((facets.getBoundingClientRect().top - bannerContent.getBoundingClientRect().top) * 100) / 100);
    grid.style.setProperty('--mp-collection-filter-offset', `${offset}px`);
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(align);
  }

  function watch() {
    observer?.disconnect();
    resizeObserver?.disconnect();

    const banner = document.querySelector('.section-main-collection-banner');
    const grid = document.querySelector('.section-main-collection-product-grid');
    const facets = grid?.querySelector('.facets-wrap');
    if (!banner || !grid || !facets) return;

    observer = new MutationObserver(schedule);
    observer.observe(facets, { attributes: true, attributeFilter: ['class'] });
    resizeObserver = new ResizeObserver(schedule);
    resizeObserver.observe(banner);
    resizeObserver.observe(grid);
    let nextSection = banner.nextElementSibling;
    while (nextSection && nextSection !== grid) {
      resizeObserver.observe(nextSection);
      nextSection = nextSection.nextElementSibling;
    }
    schedule();
  }

  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', watch);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch, { once: true });
  } else {
    watch();
  }
})();
